import router from "@/router";
import firebase from "firebase";
import { usersCollection, gamesCollection, currentCollection } from "@/main";

export const auth = {
  namespaced: true,

  state: {
    user: null,
    error: null,
    displayName: null
  },

  mutations: {
    initUser(state, payload) {
      state.user = payload.uid;
      state.displayName = payload.displayName;
      state.error = payload.error;
    },

    clearUser(state) {
      (state.user = null), (state.displayName = null), (state.error = null);
    },

    setError(state, error) {
      state.error = error;
    }
  },

  actions: {
    newregisterAction({ rootGetters, getters, commit, dispatch }, payload) {
      if (firebase.auth().currentUser) dispatch("signOutAction");
      firebase
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.password)
        .then(userCredentials => {
          if (userCredentials.user) {
            console.log(userCredentials)
            userCredentials.user
              .updateProfile({
                displayName: payload.name
              })
              .then(s => {
                usersCollection.doc(userCredentials.user.uid).set({
                  displayName: userCredentials.user.displayName,
                  createdAt: firebase.firestore.FieldValue.serverTimestamp()
                });

                commit("initUser", {
                  uid: userCredentials.user.uid,
                  displayName: userCredentials.user.displayName,
                  error: null
                });
                commit("resetProjects", null, { root: true });
                dispatch("savePortfolio", null, { root: true });
                // const currentGame = rootGetters["game/currentGame"];
                // if (rootGetters["game/currentGame"].open) {
                // const currentGame = rootGetters.currentGame;

                router.push("/playoptions");
                //  currentCollection.doc("game").get()
                //   .then(currentGame => {
                // if (currentGame.open) {
                //   router.push("/playoptions");
                // } else {
                //   commit("setGroupPlay", false, { root: true });
                //   dispatch("tabulateResults", null, { root: true });
                //   router.push("/selectfunds");
                // }
                //  });
                // if (rootGetters.currentGame.open) {
                //   router.push("/playoptions");
                // } else {
                //   commit("setGroupPlay", false, { root: true });
                //   dispatch("tabulateResults",null, { root: true });
                //   router.push("/selectfunds");
                // }
              });
          }
        })
        .catch(function(error) {
          if (error.code === "auth/email-already-in-use")
            console.log(error.code);
          dispatch("signInAction", payload);
        });
    },

    signInAction({ rootGetters, commit, dispatch }, payload) {
      firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password)
        .then(response => {
          console.log(response)
          commit("initUser", {
            uid: response.user.uid,
            displayName: response.user.displayName,
            error: null
          });
          commit("resetProjects", null, { root: true });
          dispatch("savePortfolio", null, { root: true });
          // const currentGame = rootGetters["game/currentGame"];
          // if (rootGetters["game/currentGame"].open) {

          // const currentGame = rootGetters.currentGame;

          // currentCollection.doc("game").get()
          // .then(currentGame => {

          // if (rootGetters.currentGame.open) {
          //   router.push("/playoptions");
          // } else {
          //   commit("setGroupPlay", false, { root: true });
          //   dispatch("tabulateResults", null, { root: true });
          //   router.push("/selectfunds");
          // }


          router.push("/playoptions");
          //  });
          // console.log("SignIn:  ", JSON.stringify(rootGetters.currentGame));
          // if (rootGetters.currentGame.open) {

          //   router.push("/playoptions");
          // } else {
          //   commit("setGroupPlay", false, { root: true });
          //   dispatch("tabulateResults",null, { root: true });
          //   router.push("/selectfunds");
          // }
        })
        .catch(error => {
          // commit("setStatus", "failure");
          commit("setError", error.message);
          alert(error.message);
        });
    },

    signOutAction({ commit }) {
      // console.log("Sign Out:  "+firebase.auth().currentUser.uid, firebase.auth().currentUser.displayName);
      firebase
        .auth()
        .signOut()
        .then(response => {
          commit("clearUser");
          // console.log("Clearing Results")
          commit("clearResults", {}, { root: true });
          commit("resetProjects", null, { root: true });
          commit("setGroupPlay", false, { root: true });
        })
        .catch(error => {
          // commit("setStatus", "failure");
          commit("setError", error.message);
          console.log("signOutAction", error.message);
        });
    }
  },

  getters: {
    status(state) {
      return state.status;
    },

    user(state) {
      return state.user;
    },

    isUserAuth(state) {
      // return !!state.user;
      if (state.user) {
        return true;
      }
      return false;
    },

    displayName(state) {
      return state.displayName;
    },

    error(state) {
      return state.error;
    }
  }
};
